import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRightFromBracket,
  faGear,
  faShield,
} from "@fortawesome/free-solid-svg-icons";
import { Popover } from "@headlessui/react";
import Link from "components/Link";
import ProfileSettings from "./ProfileSettings";
import { useLocation } from "react-router-dom";

export default function Navigation() {
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const [isHomePage, setisHomePage] = useState(location.pathname === "/");

  useEffect(() => {
    setisHomePage(location.pathname === "/");
  }, [location.pathname]);

  return (
    <div className="relative flex justify-end items-center p-4 pb-10 lg:pb-0">
      {!isHomePage && (
        <Link className="" to="/">
          <FontAwesomeIcon className="me-2" icon={faArrowLeft} /> Ana səhifə
        </Link>
      )}

      {user.id == null && (
        <p className="flex gap-4">
          <Link
            to="login"
            className="flex-grow font-bold text-violet-200  hover:text-violet-300 duration-200 hover:underline"
          >
            Giriş
          </Link>
          /
          <Link
            to="register"
            className="flex-grow font-bold text-violet-200  hover:text-violet-300 duration-200 hover:underline"
          >
            Qeydiyyat
          </Link>
        </p>
      )}
      {user.id != null && (
        <div className="flex items-center gap-3">
          <Popover className="relative">
            <Popover.Button className="flex gap-2 items-center outline-none px-2 border border-transparent hover:border-slate-500 rounded">
              <h2>{user?.firstName}</h2>
              <div className="h-8 w-8 flex items-center justify-center">
                <FontAwesomeIcon icon={faGear} />
              </div>
            </Popover.Button>

            <Popover.Panel className="fixed inset-7 bottom-auto rounded bg-slate-900 p-4 lg:absolute lg:inset-auto z-10 shadow-2xl drop-shadow-2xl lg:right-0 lg:top-[115%] lg:w-80">
              {({ close }) => {
                return (
                  <div className="space-y-3">
                    <div className="border-b">
                      <h3 className="text-lg mb-4">Profil ayarları</h3>
                      <ProfileSettings close={close} user={user} />
                    </div>

                    <Link
                      className="flex items-center gap-2 p-2 border rounded justify-between"
                      to="/change-password"
                    >
                      <h3 className="text-md">Şifrəni dəyiş</h3>
                      <FontAwesomeIcon icon={faShield} />
                    </Link>

                    <Link
                      className="flex items-center gap-2 p-2 border rounded justify-between"
                      to="/logout"
                    >
                      <h3 className="text-md">Çıxış</h3>
                      <FontAwesomeIcon icon={faArrowRightFromBracket} />
                    </Link>
                  </div>
                );
              }}
            </Popover.Panel>
          </Popover>
        </div>
      )}
      {/* <h1 className="flex flex-col sm:flex-row justify-between items-center">
        {user.id == null && (
          <p className="flex gap-4">
            <Link
              to="login"
              className="flex-grow font-bold text-violet-200  hover:text-violet-300 duration-200 hover:underline"
            >
              Giriş
            </Link>
            /
            <Link
              to="register"
              className="flex-grow font-bold text-violet-200  hover:text-violet-300 duration-200 hover:underline"
            >
              Qeydiyyat
            </Link>
          </p>
        )}
        {user.id != null && (
          <div className="flex items-center gap-3">
            <Popover className="relative">
              <Popover.Button className="flex gap-2 items-center px-2  border rounded">
                <h2>{user?.firstName}</h2>
                <div className="h-8 w-8 flex items-center justify-center">
                  <FontAwesomeIcon icon={faEllipsisVertical} />
                </div>
              </Popover.Button>

              <Popover.Panel className="absolute z-10 rounded shadow-2xl drop-shadow-2xl lg:right-0 right-1/2 lg:-translate-x-0 -translate-x-1/2 top-[125%] w-60 lg:dw-80 bg-slate-900 p-3">
                <div>
                  <Link
                    className="flex items-center gap-2 py-2 border-b justify-between"
                    to="/logout"
                  >
                    <h3 className="text-md">Profil ayarları</h3>
                    <FontAwesomeIcon icon={faUser} />
                  </Link>

                  <Link
                    className="flex items-center gap-2 py-2 justify-between"
                    to="/logout"
                  >
                    <h3 className="text-md">Çıxış</h3>
                    <FontAwesomeIcon icon={faArrowRightFromBracket} />
                  </Link>
                </div>
              </Popover.Panel>
            </Popover>
          </div>
        )}
      </h1> */}
    </div>
  );
}
